import { Layout, Typography } from 'antd';
import React from 'react';
const { Header, Content, Footer } = Layout;
const { Title } = Typography;

export const AdminApp: React.FC = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div className="bg-gray-100">
      <Header style={{ backgroundColor: '#001529', padding: '10px 20px' }}>
        <Title level={3} style={{ color: '#fff', margin: 0 }}>
          Admin Dashboard
        </Title>
      </Header>
      <Content style={{ padding: '50px' }}>
        <div className="mx-auto">{children}</div>
      </Content>
      <Footer style={{ textAlign: 'center' }}>© {new Date().getFullYear()} najmuje.com</Footer>
    </div>
  );
};
